<template>
  <div class="page__wrapper" @scroll="onScroll()">
    <FCCopy :h2="this.h2" :h3="this.h3">
      <template v-slot:copy>
        <strong>The most unique premium sports ticket in the market. A high end all-inclusive, field-side experience woven into the spectacle of the player walk-out tunnel. This intimate premium experience offers only 390 total seats to the ultimate fan experience.</strong>
        <p class="map">
          <img
            src="~@/assets/maps/map-tunnelclub.png"
            alt
            data-aos="zoom-in-up"
            data-aos-duration="250"
            data-aos-easing="ease-out-cubic"
          />
        </p>
      </template>
    </FCCopy>
  </div>
</template>

<script>
import FCCopy from "@/components/patterns/FCCopy";
export default {
  components: {
    FCCopy
  },
  mounted() {
    const ref = this.$store.state.menu.tunnelClub.ref;
    const index = this.$store.state.menu.menuItems.map(e => e.ref).indexOf(ref);
    this.$store.state.menu.activeSection = index;
    this.$store.state.menu.currentSectionTitle = this.$store.state.menu.tunnelClub.title;
    this.$store.state.menu.currentSectionNavigation = this.$store.state.menu.tunnelClub.nav;
    this.onScroll();
  },
  data() {
    return {
      h2: "Tunnel Club",
      h3: "Intro"
    };
  }
};
</script>

<style lang="scss" scoped>
.page__wrapper {
  background-image: url("~@/assets/backgrounds/bg-tunnel-intro.jpg");
  background-size: cover;
  background-position: center;
}
</style>